import {
	checkCertificatePipelineWorkDepth,
	createCertificatePipelineWorkDepth,
	IVIPCertificatePipelineWorkDepth,
	checkCertificatePipelineWorkSite,
	createCertificatePipelineWorkSite,
	IVIPCertificatePipelineWorkSite,
	VIPCertificatePipelineType
} from "@/loader";


export interface IVIPCertificatePipelineWork {
	diameter: string;
	materials: string;
	type: VIPCertificatePipelineType;
	site: IVIPCertificatePipelineWorkSite;
	depth: IVIPCertificatePipelineWorkDepth;
	drawdown: IVIPCertificatePipelineWorkDepth;
}

export function createVIPCertificatePipelineWork(): IVIPCertificatePipelineWork {
	return {
		diameter: "",
		materials: "",
		type: 0,
		site: createCertificatePipelineWorkSite(),
		depth: createCertificatePipelineWorkDepth(),
		drawdown: createCertificatePipelineWorkDepth(),
	};
}

export function checkVIPCertificatePipelineWork(data: IVIPCertificatePipelineWork) {
	if (data.diameter === undefined) {
		data.diameter = "";
	}
	if (data.materials === undefined) {
		data.materials = "";
	}
	if (data.type === undefined) {
		data.type = 0;
	}
	if (data.site === undefined) {
		data.site = createCertificatePipelineWorkSite();
	} else {
		checkCertificatePipelineWorkSite(data.site);
	}
	if (data.depth === undefined) {
		data.depth = createCertificatePipelineWorkDepth();
	} else {
		checkCertificatePipelineWorkDepth(data.depth);
	}
	if (data.drawdown === undefined) {
		data.drawdown = createCertificatePipelineWorkDepth();
	} else {
		checkCertificatePipelineWorkDepth(data.depth);
	}
}
